import { MuiTheme } from "theme";
import { makeStyles } from "@material-ui/core/styles";
import Breakpoints from "common/breakpoints";
import {
  VIDEO_LIST_WIDTH,
  TRACK_OPTICS_HEADERS_HEIGHT,
  TRACK_OPTICS_HEADERS_MOBILE_HEIGHT
} from "../VideoDetails/styles";

const TRACK_OPTICS_HEADERS_SMALL_MOBILE_HEIGHT = 204;

export default makeStyles((theme: MuiTheme) => {
  const {
    palette: { primary },
    breakpoints
  } = theme;

  return {
    videoListWrap: {
      width: VIDEO_LIST_WIDTH,
      [breakpoints.down(Breakpoints.SM_600)]: {
        width: "100%"
      }
    },
    listRoot: {
      padding: 0,
      backgroundColor: "#fff",
      maxHeight: `calc(100dvh - ${TRACK_OPTICS_HEADERS_HEIGHT}px)`,
      overflowY: "auto",
      [breakpoints.down(Breakpoints.SM_600)]: {
        maxHeight: `calc(100dvh - ${TRACK_OPTICS_HEADERS_MOBILE_HEIGHT}px)`
      },
      [breakpoints.down(Breakpoints.XS_420)]: {
        maxHeight: `calc(100dvh - ${TRACK_OPTICS_HEADERS_SMALL_MOBILE_HEIGHT}px)`
      }
    },
    listItemRoot: {
      display: "block",
      padding: "12px 28px",
      borderBottom: `1px solid ${primary.light}`,
      "&:nth-child(odd)": {
        backgroundColor: "#f6f6f6"
      },
      "&:hover": {
        backgroundColor: "#e8f6f1"
      },
      "&.Mui-selected": {
        backgroundColor: "#e8f6f1",
        "&:hover": {
          backgroundColor: "#e8f6f1"
        }
      }
    },
    listItemRootRow: {
      display: "flex",
      alignItems: "center",
      height: 24,
      fontSize: 12,
      color: "#1a1a1a",
      "&:first-child": {
        fontSize: 14,
        fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
        color: primary.main
      }
    }
  };
});
